export default __webpack_public_path__ + "static/media/iron-man.1aa64fd1.jpg";